"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FieldDescriptor = /** @class */ (function () {
    function FieldDescriptor() {
    }
    FieldDescriptor.TYPE_DOUBLE = 1;
    FieldDescriptor.TYPE_FLOAT = 2;
    FieldDescriptor.TYPE_INT64 = 3;
    FieldDescriptor.TYPE_UINT64 = 4;
    FieldDescriptor.TYPE_INT32 = 5;
    FieldDescriptor.TYPE_FIXED64 = 6;
    FieldDescriptor.TYPE_FIXED32 = 7;
    FieldDescriptor.TYPE_BOOL = 8;
    FieldDescriptor.TYPE_STRING = 9;
    FieldDescriptor.TYPE_GROUP = 10;
    FieldDescriptor.TYPE_MESSAGE = 11;
    FieldDescriptor.TYPE_BYTES = 12;
    FieldDescriptor.TYPE_UINT32 = 13;
    FieldDescriptor.TYPE_ENUM = 14;
    FieldDescriptor.TYPE_SFIXED32 = 15;
    FieldDescriptor.TYPE_SFIXED64 = 16;
    FieldDescriptor.TYPE_SINT32 = 17;
    FieldDescriptor.TYPE_SINT64 = 18;
    FieldDescriptor.MAX_TYPE = 18;
    return FieldDescriptor;
}());
exports.default = FieldDescriptor;
